import React from "react";
import EarlyAccessButton from "@/components/HomePageVariant/EarlyAccessButton";
import styles from "./styles.module.scss";

interface StepListSectionProps {
  onDownloadClick: () => void;
}

/**
 * StepListSection 组件 - 无动画的平面展示版本
 * 显示从意图到行动计划的内容，并直接展示视频
 */
const StepListSection = ({ onDownloadClick }: StepListSectionProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        {/* 左侧部分 - 文本内容 */}
        <div className={styles.textContentSection}>
          <div className={styles.textContentInner}>
            <h2 className={styles.mainTitle}>
              Fellou is for <span className={styles.highlight}>Answers.</span>
            </h2>
            <div className={styles.promptComparisonText}>
              <div className={styles.promptComparisonLine}>Stop clicking, start getting. </div>
              <div className={styles.promptComparisonLine}>Fellou finds what you're looking for, fast.</div>
            </div>

            <EarlyAccessButton onClick={onDownloadClick} />
          </div>
        </div>

        {/* 右侧部分 - 视频展示（替代动画演示） */}
        <div className={styles.videoSection}>
          <div className={styles.videoContainer}>
            <video autoPlay muted loop playsInline className={styles.videoElement}>
              <source
                src="https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/Website+main+page+animation/Step+List.webm"
                type="video/webm"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepListSection;
